/**
 * @generated SignedSource<<7cf05fb12f2610b372a982a12427017b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreview_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShallowAnswerPreview_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewAddress_answer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerPreviewBudget_answer"
    }
  ],
  "type": "AnswerBase",
  "abstractKey": "__isAnswerBase"
};

node.hash = "c76bf1cc50cf73e69e774547230b4ded";

module.exports = node;
